import { Input } from "antd"
import Form, { FormInstance } from "antd/lib/form"
import { Store } from "antd/lib/form/interface"
import React from "react"
import { useTranslation } from "react-i18next"
import { createCompanySettingsRules } from "./rules/companySettings.rules"

interface MileageDistanceBufferFormProps {
    formInstance: FormInstance
    onSubmit: (values: Store) => void
}
export const MileageDistanceBufferForm = ({ formInstance, onSubmit }: MileageDistanceBufferFormProps) => {
    const { t } = useTranslation()
    const rules = createCompanySettingsRules()

    return (
        <Form form={formInstance} layout="vertical" onFinish={onSubmit} autoComplete="off">
            <div className="mb-24 finway-gray-text">{t("info:mileage.distance_buffer")}</div>
            <Form.Item
                name={["mileageDistanceBuffer"]}
                label={t("input:company_settings.distance_buffer")}
                key="mileageDistanceBuffer"
                required
                rules={[...rules.mileageDistanceBuffer, ...rules.required]}
            >
                <Input placeholder={t("placeholder:company_settings.distance_buffer")} />
            </Form.Item>
        </Form>
    )
}
